import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import ReactFlagsSelect from "react-flags-select";
import "react-phone-input-2/lib/style.css";
import { FaArrowRight } from "react-icons/fa";
import { addToCart } from "../../../redux/actions/CartActions";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import Loader from "../../../components/loader/Loader";
import FormalityHeader from "../../../components/header/FormalityHeader";
import "../../styles/flow-form.css";

// Validation schema
const validationSchema = Yup.object({
  residencyCountry: Yup.string().required("Le pays est requis"),
  residencyRegion: Yup.string().required("La région est requise"),
  residencyDept: Yup.string().required("Le département est requis"),
  residencyPlace: Yup.string().required("Le lieu est requis"),
  residencyStreet: Yup.string().required("La rue est requise"),
});

// Données Cameroun : Régions et Départements
const countryRegionDepartmentData = {
  CM: {
    Adamaoua: ["Djérem", "Faro-et-Déo", "Mayo-Banyo", "Mbéré", "Vina"],
    Centre: [
      "Haute-Sanaga",
      "Lekié",
      "Mbam-et-Inoubou",
      "Mbam-et-Kim",
      "Méfou-et-Afamba",
      "Méfou-et-Akono",
      "Mfoundi",
      "Nyong-et-Kéllé",
      "Nyong-et-Mfoumou",
      "Nyong-et-So’o",
    ],
    Est: ["Boumba-et-Ngoko", "Haut-Nyong", "Kadey", "Lom-et-Djerem"],
    "Extrême-Nord": [
      "Diamaré",
      "Logone-et-Chari",
      "Mayo-Danay",
      "Mayo-Kani",
      "Mayo-Sava",
      "Mayo-Tsanaga",
    ],
    Littoral: ["Moungo", "Nkam", "Sanaga-Maritime", "Wouri"],
    Nord: ["Bénoué", "Faro", "Mayo-Louti", "Mayo-Rey"],
    "Nord-Ouest": [
      "Boyo",
      "Bui",
      "Donga-Mantung",
      "Menchum",
      "Mezam",
      "Momo",
      "Ngo-ketunjia",
    ],
    Ouest: [
      "Bamboutos",
      "Haut-Nkam",
      "Hauts-Plateaux",
      "Koung-Khi",
      "Menoua",
      "Mifi",
      "Ndé",
      "Noun",
    ],
    Sud: ["Dja-et-Lobo", "Mvila", "Océan", "Vallée-du-Ntem"],
    "Sud-Ouest": [
      "Fako",
      "Koupé-Manengouba",
      "Lebialem",
      "Manyu",
      "Meme",
      "Ndian",
    ],
  },
};

function PassportResidencePlace() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (values) => {
    setSubmitting(true);
    await dispatch(
      addToCart({
        ...values,
      })
    );

    navigate("/passport-id");
  };

  return (
    <div className="legacy-flow">
      <FormalityHeader from={cart.from} />
      <Loader isLoading={submitting} />

      <div className="container mt-3 text-center" style={{ maxWidth: "800px" }}>
        <h4 className="text-center mt-4 mb-4">
          Quel est votre{" "}
          <span style={{ color: "#FF5500" }}>Lieu de résidence</span> ?
        </h4>
      </div>

      <div className="container mt-4 d-flex justify-content-center">
        <Formik
          initialValues={{
            residencyCountry: "",
            residencyRegion: "",
            residencyDept: "",
            residencyPlace: "",
            residencyStreet: "",
          }}
          validationSchema={validationSchema}
          onSubmit={async (values) => {
            handleSubmit(values);
          }}
        >
          {({ setFieldValue, values, errors, touched }) => (
            <Form
              className="w-100"
              style={{ textAlign: "left", maxWidth: "400px" }}
            >
              {/* Country selector */}
              <div className="mb-3">
                <label htmlFor="birthDate">Pays</label>
                <ReactFlagsSelect
                  selected={values.residencyCountry}
                  countries={["CM"]}
                  onSelect={(code) => {
                    setFieldValue("residencyCountry", code);
                    setFieldValue("residencyRegion", "");
                    setFieldValue("residencyDept", "");
                  }}
                  placeholder="Pays de résidence"
                  searchable
                  searchPlaceholder="Recherchez le pays"
                  className="w-100"
                />
                {errors.residencyCountry && touched.residencyCountry && (
                  <div className="text-danger" style={{ fontSize: "12px" }}>
                    {errors.residencyCountry}
                  </div>
                )}
              </div>

              {/* Region selector */}
              <div className="mb-3">
                <label htmlFor="birthDate">Region</label>
                <Select
                  options={
                    values.residencyCountry
                      ? Object.keys(
                          countryRegionDepartmentData[values.residencyCountry]
                        ).map((region) => ({ label: region, value: region }))
                      : []
                  }
                  value={
                    values.residencyRegion
                      ? {
                          label: values.residencyRegion,
                          value: values.residencyRegion,
                        }
                      : null
                  }
                  onChange={(selected) => {
                    setFieldValue("residencyRegion", selected.value);
                    setFieldValue("residencyDept", "");
                  }}
                  placeholder="Région"
                  isDisabled={!values.residencyCountry}
                  isSearchable
                />
                {errors.residencyRegion && touched.residencyRegion && (
                  <div className="text-danger" style={{ fontSize: "12px" }}>
                    {errors.residencyRegion}
                  </div>
                )}
              </div>

              {/* Department selector */}
              <div className="mb-3">
                <label htmlFor="birthDate">Département</label>
                <Select
                  options={
                    values.residencyRegion
                      ? countryRegionDepartmentData[values.residencyCountry][
                          values.residencyRegion
                        ].map((dep) => ({ label: dep, value: dep }))
                      : []
                  }
                  value={
                    values.residencyDept
                      ? {
                          label: values.residencyDept,
                          value: values.residencyDept,
                        }
                      : null
                  }
                  onChange={(selected) =>
                    setFieldValue("residencyDept", selected.value)
                  }
                  placeholder="Département"
                  isDisabled={!values.residencyRegion}
                  isSearchable
                />
                {errors.residencyDept && touched.residencyDept && (
                  <div className="text-danger" style={{ fontSize: "12px" }}>
                    {errors.residencyDept}
                  </div>
                )}
              </div>

              <div className="mb-3">
                <label htmlFor="birthDate">Lieu de residence</label>
                <Field
                  name="residencyPlace"
                  className="form-control"
                  placeholder="Lieu de maissance"
                  style={{ height: "50px" }}
                />
                {errors.residencyPlace && touched.residencyPlace && (
                  <div className="text-danger" style={{ fontSize: "12px" }}>
                    {errors.residencyPlace}
                  </div>
                )}
              </div>

              <div className="mb-3">
                <label htmlFor="birthDate">Rue</label>
                <Field
                  name="residencyStreet"
                  className="form-control"
                  placeholder="Rue"
                  style={{ height: "50px" }}
                />
                {errors.residencyStreet && touched.residencyStreet && (
                  <div className="text-danger" style={{ fontSize: "12px" }}>
                    {errors.residencyStreet}
                  </div>
                )}
              </div>

              {/* Submit button */}
              <div className="d-flex justify-content-center">
                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{
                    backgroundColor: "#051259",
                    borderRadius: "10px",
                    color: "#fff",
                    width: "180px",
                    padding: "10px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  Suivant
                  <FaArrowRight style={{ marginLeft: "8px" }} />
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

export default PassportResidencePlace;
